import * as React from 'react';
import { Route, Routes } from 'react-router';

import { PrivateRoute } from './PrivateRoute';
import { ProjectDocEdit } from '../pages/projectDocs/components/ProjectDocEdit';
import { ProjectDocsList } from '../pages/projectDocs/components/ProjectDocsList';
import { StandartSolutionFolderList } from '../pages/standartSolutions/components/StandartSolutionFolderList';
import { UnAuthorizedPage } from '../pages/unAuthorized/components/UnAuthorizedPage';
import { FaqList } from '../pages/faq/components/FaqList';
import { ReportsList } from '../pages/reports/components/ReportsList';
import { ReferenceReport } from '../pages/referenceReport/components/ReferenceReport';
import { ProjectConsolidated } from '../pages/projectConsolidated/components/ProjectConsolidated';
import { TitleableRoute } from './TitleableRoute';
import environment from '../helpers/environment';
import { RegistrationPage } from '../pages/registration/components/RegistrationPage';
import { LoginPage } from '../pages/login/components/LoginPage';
import { ProfilePage } from '../pages/profile/components/ProfilePage';
import { MyUsersList } from '../pages/users/components/MyUsersList';
import { MyUserEdit } from '../pages/users/components/MyUserEdit';
import { BlockedPage } from '../pages/users/components/BlockedPage';

export interface AppRouteProps {
    isPublic?: boolean;
    allowWithoutContractors?: boolean;
    title: string;
    path: string;
    component: React.ComponentType;
}

const routeItems: AppRouteProps[] = [
    // {
    //   path: `/tasks`,
    //   component: TasksList,
    // },
    {
        path: `/`,
        title: 'Документы',
        component: ProjectDocsList
    },
    {
        path: `/projectdocs`,
        title: 'Документы',
        component: ProjectDocsList
    },
    {
        path: `/projectdocs/:id`,
        title: 'Документ',
        component: ProjectDocEdit
    },
    {
        path: `/standartsolutions`,
        title: 'Стандартные решения',
        component: StandartSolutionFolderList
    },
    {
        path: `/reports`,
        title: 'Отчеты',
        component: ReportsList
    },
    {
        path: `/projectConsolidated`,
        title: 'Сводный отчет по ПД и РД',
        component: ProjectConsolidated
    },
    {
        path: `/referenceReport`,
        title: 'Справка',
        component: ReferenceReport
    },
    {
        path: `/profile`,
        title: 'Профиль',
        component: ProfilePage,
        allowWithoutContractors: true
    },
    {
        path: `/my-users`,
        title: 'Мои пользователи',
        component: MyUsersList,
        allowWithoutContractors: true
    },
    {
        path: `/my-users/create`,
        title: 'Создание пользователя',
        component: MyUserEdit,
        allowWithoutContractors: true
    },
    {
        path: `/my-users/:id`,
        title: 'Редактирование пользователя',
        component: MyUserEdit,
        allowWithoutContractors: true
    },
    {
        path: `/registration`,
        title: 'Регистрация',
        component: RegistrationPage,
        isPublic: true
    },
    {
        path: `/login`,
        title: 'Вход',
        component: LoginPage,
        isPublic: true
    },
    {
        path: `/faq`,
        title: 'FAQ',
        component: FaqList
    },
    {
        path: `/blocked`,
        title: 'Заблокировано',
        component: BlockedPage,
        isPublic: true
    }
];

export const AppRouting: React.FC = () => {
    return (
        <Routes>
            {routeItems.map((item: AppRouteProps, i) => {
                const { path, title, component: Component, isPublic, allowWithoutContractors } = item;
                return isPublic ? (
                    <Route
                        path={path}
                        element={<TitleableRoute title={title} element={<Component />} />}
                        key={`AppRouting-${i}`}
                    />
                ) : (
                    <Route
                        path={path}
                        element={
                            <PrivateRoute
                                title={title}
                                component={Component}
                                path={path}
                                allowWithoutContractors={allowWithoutContractors}
                            />
                        }
                        key={`AppRouting-${i}`}
                    />
                );
            })}
            <Route
                path={`/unauthorized`}
                element={<TitleableRoute title={environment.websiteName} element={<UnAuthorizedPage />} />}
            />
        </Routes>
    );
};
